const ITEMS = ["Mindset", "Movement", "Recovery", "Resilience", "Community"];

const Marquee = () => (
  <div className="marquee" aria-hidden="true" data-testid="brand-marquee">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div className="marquee-group" key={copy}>
          {ITEMS.map((item) => (
            <span className="marquee-item" key={`${copy}-${item}`}>
              {item}
              <span className="marquee-dot" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
